import { AuthenticatedUser } from '../type/User';
import DetailedUser from '../type/DetailedUser';

const APP_PLACEHOLDER = 'iAuto';

export const saveUserAuthToLocalStorage = (authenticatedUser: AuthenticatedUser): void => {
    const appDataString = localStorage.getItem(APP_PLACEHOLDER);
    if (appDataString) {
        const appData = JSON.parse(appDataString);
        const updatedPersistObject = {
            ...appData,
            userAuth: authenticatedUser,
        };

        localStorage.setItem(APP_PLACEHOLDER, JSON.stringify(updatedPersistObject));
    }
};

export const getUserAuthFromLocalStorage = (): DetailedUser | any => {
    const appDataString: string | null = localStorage.getItem(APP_PLACEHOLDER);

    if (appDataString) {
        const appData = JSON.parse(appDataString);
        const userAuth = appData.userAuth;

        return {
            authenticatedUser: userAuth,
        };
    } else {
        return {
            authenticatedUser: undefined
        };
    }
};

export const removeUserAuthFromLocalStorage = (): void => {
    const appDataString: string | null = localStorage.getItem(APP_PLACEHOLDER);

    if (appDataString) {
        const appData = JSON.parse(appDataString);

        if (appData.hasOwnProperty('userAuth')) {
            delete appData.userAuth;
            localStorage.setItem(APP_PLACEHOLDER, JSON.stringify(appData));
        }
    }
};
